<template>
  <div id = "app">
    <div id = "nav">
      <div id = "routing">
        <router-link to = "/">Home</router-link>
        <router-link to = "/about">About</router-link>
      </div>
    </div>
    <vue-page-transition name = "zoom">
      <router-view/>
    </vue-page-transition>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        loaded: false,
      }
    },
  }
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=Roboto&display=swap');
#app {
  height: 100vh;
  font-family: 'Roboto', sans-serif;
  text-align: center;
  background: linear-gradient(-45deg, #3498db, #2c3e50, #8e44ad);
  background-size: 400% 400%;
  animation: Gradient 12s ease infinite;
  @keyframes Gradient {
    0% {background-position: 0 50%}
    50% {background-position: 100% 50%}
    100% {background-position: 0 50%}
  }
}

#nav {
  padding: 30px;
  font-size: 24px;
  text-align: right;
}

#routing {
  a {
    margin: 12px;
    text-decoration: none;
    color: #ccc;
    &.router-link-exact-active {
      border-bottom: 1px solid #ccc;
    }
    &:hover {
      color: #bbb;
    }
  }
}
</style>
